/**
 * Carousel Progress Bar - Version ultra simplifiée
 */

// Fonction pour mettre à jour la barre de progression
function updateProgressBar(position, max) {
  var progressBar = document.querySelector(".carousel-progress-bar");
  if (progressBar) {
    var progressPercentage = (position / max) * 100;
    progressBar.style.width = progressPercentage + "%";
    console.log("Progress updated to: " + progressPercentage + "%");
  } else {
    console.log("Progress bar not found");
  }
}

// Fonction d'initialisation
function initProgressBar() {
  console.log("Initializing progress bar");

  // Vérifier si la section a une gestion de progression personnalisée
  var customProgressSection = document.querySelector(
    '[data-custom-progress="true"]',
  );
  if (customProgressSection) {
    console.log(
      "Section with custom progress detected, skipping global progress bar initialization",
    );
    return;
  }

  // Sélectionner les éléments
  var nextButton = document.querySelector("[data-next]");
  var prevButton = document.querySelector("[data-prev]");
  var slides = document.querySelectorAll(".recommended-products__slide");

  if (!nextButton || !prevButton) {
    console.log("Navigation buttons not found");
    return;
  }

  if (!slides.length) {
    console.log("Slides not found");
    return;
  }

  console.log("Found " + slides.length + " slides");

  // Nombre total de slides et slides visibles
  var totalSlides = slides.length;
  var visibleSlides = 4; // Ajuster selon la configuration du thème
  var maxPosition = totalSlides - visibleSlides;

  // Position actuelle
  var currentPosition = 0;

  // Initialiser la barre de progression
  updateProgressBar(currentPosition, maxPosition);

  // Ajouter des écouteurs d'événements aux boutons
  nextButton.addEventListener("click", function () {
    console.log("Next button clicked");
    if (currentPosition < maxPosition) {
      currentPosition++;
      updateProgressBar(currentPosition, maxPosition);
    }
  });

  prevButton.addEventListener("click", function () {
    console.log("Previous button clicked");
    if (currentPosition > 0) {
      currentPosition--;
      updateProgressBar(currentPosition, maxPosition);
    }
  });
}

// S'assurer que le script est exécuté après le chargement du DOM
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProgressBar);
} else {
  initProgressBar();
}

// Réessayer après un délai pour s'assurer que tous les éléments sont chargés
setTimeout(initProgressBar, 1000);
